"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    content: {
        width: '100%',
        position: 'relative',
        color: theme.warningRed,
        fontSize: 12,
        letterSpacing: '0.24px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        padding: '4px 0'
    }
});
//# sourceMappingURL=errorMessage.style.js.map